//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AutoPopulateSideTwoOption",1,0],[1,"BodySelection",0,"SelectBodyList",0],[0,"HideBodyOption",1,0],[1,"IgnoreFaceSelection",0,"ScCollector",0],[0,"MergeAngleTolerance",1,0],[0,"PairingStrategy",1,0],[1,"SearchDistance",0,"Expression",0],[1,"SheetSelection",0,"SelectBodyList",0],[1,"SideOneSelection",0,"ScCollector",0],[1,"SideTwoSelection",0,"ScCollector",0],[0,"ThicknessRatio",1,0],[1,"ThicknessValue",0,"Expression",0],[0,"TrimmingOption",1,0],[0,"UpdateOption",1,0],[1,"UserDefinedMidSurfaceSelection",0,"SelectDisplayableObjectList",0]],[[[],"AutoPopulateSideTwo",{},0,0],[["nFacePairs"],"CreateFacePair",{R_:{facePairs:"Features.Feature[]"}},0,0],[["facePairs"],"ReverseFacePair",{},1,0],[["surfaceOption","facePairs"],"ModifyMidsurface",{},2,0],[["facePairs"],"DeleteFacePair",{},1,0],[["facePairs"],"MergeFacePairs",{},1,0],[["trimmingOption","facePairs"],"Trim",{},2,0],[["facePair"],"SetupFacePairInContext",{},1,0],[["selectionType"],"ValidateSelection",{},1,0]],[]];
SPLM.Features.MidSurfaceByFacePairsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MidSurfaceByFacePairsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MidSurfaceByFacePairsBuilder.PairingStrategyType = Object.freeze({
    "Progressive" : "Progressive", "Thickness" : "Thickness", "Manual" : "Manual"});

SPLM.Features.MidSurfaceByFacePairsBuilder.TrimmingOptionType = Object.freeze({
    "AdvancedTrimming" : "AdvancedTrimming", "BodyBasedTrimming" : "BodyBasedTrimming", "TrimtoSide1withNoExtension" : "TrimtoSide1withNoExtension", "SkipTrimming" : "SkipTrimming"});

SPLM.Features.MidSurfaceByFacePairsBuilder.SurfaceType = Object.freeze({
    "Standard" : "Standard", "Side1" : "Side1", "Offset" : "Offset", "CloudOfPoints" : "CloudOfPoints", "Large" : "Large"});

export default SPLM;